import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { Http } from "@status/codes";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { UpdateNotificationTemplate } from "../../models/update-template.model";
import Vuetify from "vuetify";
import { NotificationTemplate } from "@/modules/Notification/models/NotificationTemplate";
import {
  NOTIFICATION_TEMP_CONSTANTS,
  EMIT_EVENTS,
  NOTIFICATION_TEMP_MESSAGES,
  LISTS_NAMES,
  NOTIFICATION_ACCESS,
  TEMPLATE_TYPE_CONFIG,
  TEMPLATE_CHANNEL_CONFIG,
  TEMPLATE_CATEGORY_CONFIG
} from "../../constants/NotificationTemplateConstants";
import { NotificationTemplateLinkPreview } from "../../models/notification-template-link-preview.model";
import { NotificationTemplateServices } from "../../services/NotificationTemplateService";
import EditTemplateListsModal from "../EditTemplateListsModal/EditTemplateListsModal.vue";
import { ListOptions } from "../../models/list-options.model";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import { Utils } from "../../../../shared/utils/utils";
import { AxiosError } from "axios";
import {
  ACTIVE,
  INACTIVE
} from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import ChipCounter from "../../../../shared/components/ChipCounter/ChipCounter.vue";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { ParameterConfig } from "../../models/parameter-config.model";
import lodash from "lodash";
import { NotificationParams } from "@/modules/Notification/models/NotificationParams";
import { NotificationForm } from "../../models/NotificationForm.model";

Vue.use(Vuetify);
@Component({
  name: "SaveNotificationTemplate",
  components: {
    ModalTemplate,
    EditTemplateListsModal,
    DocumentViewer,
    ChipCounter,
    DynamicSelect
  }
})
export default class SaveNotificationTemplate extends Vue {
  @Inject() notificationTemplateService!: NotificationTemplateServices;
  @Prop() notificationTemplateIdProp!: string;
  @Prop() notificationTemplateProp!: NotificationTemplate;
  @Prop() categoryList!: ListOptions;
  @Prop() channelList!: ListOptions;
  @Prop() typeList!: ListOptions;
  @Prop() parametersConfig!: ParameterConfig[];
  @Prop({ default: false, required: false })
  public isModal!: boolean;

  ACTION: string = NOTIFICATION_TEMP_CONSTANTS.CANCEL_UPDATE;
  activateSaveBtn = false;
  CANCEL_BTN: string = NOTIFICATION_TEMP_CONSTANTS.CANCEL_BTN;
  cardClass = STYLE_CLASSES.CARD;
  chosenList: ListOptions = new ListOptions();
  contentFields: Array<string> = [];
  contentPreview = "";
  contentPreviewLink: NotificationTemplateLinkPreview = new NotificationTemplateLinkPreview();
  CONTENT_PREVIEW_IDENTIFICATOR = /\{\{[0-9]+\}\}/;
  currentPreviewFieldChange = "";
  documentDialog = false;
  editDialog = false;
  EDITING_TITLE = NOTIFICATION_TEMP_CONSTANTS.EDITING_TITLE;
  FIELD: string = NOTIFICATION_TEMP_CONSTANTS.FIELD;
  form = false;
  FORM_NAME = NOTIFICATION_TEMP_CONSTANTS.FORM_NAME;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  modalDialog = false;
  modalText = "";
  modalTitle = "";
  PREVIEW = NOTIFICATION_TEMP_CONSTANTS.PREVIEW;
  PREVIEW_USER_MESSAGE = NOTIFICATION_TEMP_CONSTANTS.PREVIEW_USER_MESSAGE;
  primaryBtn = STYLE_CLASSES.PRIMARY_BTN;
  rawContentPreview = "";
  switchClass = STYLE_CLASSES.SWITCH;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  UPDATE_BTN = NOTIFICATION_TEMP_CONSTANTS.UPDATE_BTN;
  updatedTemplate!: UpdateNotificationTemplate;
  UPDATE_TEMP: string = NOTIFICATION_TEMP_CONSTANTS.UPDATE_TEMP;
  paramsArrayConfig: ParameterConfig[][] = [];
  paramsPanels: number[][] = [];

  addICategoryMessage = "";
  addIChannelMessage = "";
  addITypeMessage = "";
  categorylListConfig = { ...TEMPLATE_CATEGORY_CONFIG };
  categorylListModel = [{ id: "", name: "" }];

  typeListConfig = { ...TEMPLATE_TYPE_CONFIG };
  typeListModel = [{ id: "", name: "" }];
  channelListConfig = { ...TEMPLATE_CHANNEL_CONFIG };
  channelListModel = [
    {
      id: NOTIFICATION_TEMP_CONSTANTS.DEFAULT_CHANNEL,
      name: NOTIFICATION_TEMP_CONSTANTS.DEFAULT_CHANNEL
    }
  ];

  notificationForm: NotificationForm = {
    templateName: "",
    category: [],
    channel: "",
    type: "",
    state: false,
    paramsArrayConfig: []
  };

  editComparationStr = "";
  invalidEdit = false;

  @Watch("localNotificationTemplateIdProp")
  notificationTemplateIdPropHandler() {
    if (this.localNotificationTemplateIdProp) {
      this.contentPreviewLink = new NotificationTemplateLinkPreview();
      this.getNotificationTemplateById(this.localNotificationTemplateIdProp);
      Utils.scrollToElement("notificationTemplateFormContent", this);
    }
  }

  beforeMount() {
    this.configList();
  }

  mounted() {
    this.notificationTemplateIdPropHandler();
  }

  configList() {
    const categoryList = this.categoryList.options.map(item => {
      return { id: item, name: item };
    });

    const typeList = this.typeList.options.map(item => {
      return { id: item, name: item };
    });

    const channelList = this.channelList.options.map(item => {
      return { id: item, name: item };
    });

    this.typeListConfig.listAll = [...typeList];
    this.channelListConfig.listAll = [...channelList];
    this.categorylListConfig.listAll = [...categoryList];

    this.addICategoryMessage = NOTIFICATION_TEMP_CONSTANTS.ADD_CATEGORY;
    this.addIChannelMessage = NOTIFICATION_TEMP_CONSTANTS.ADD_CHANNEL;
    this.addITypeMessage = NOTIFICATION_TEMP_CONSTANTS.ADD_TYPE;
  }

  get localNotificationTemplateIdProp() {
    return this.notificationTemplateIdProp;
  }

  set category(ids: string[]) {
    this.categorylListModel = ids.map(id => {
      return { id, name: id };
    });
  }

  get category() {
    return this.categorylListModel.map(item => item.id);
  }

  set type(id: string) {
    this.typeListModel = [{ id, name: id }];
  }

  get type() {
    return this.typeListModel[0].id;
  }

  set channel(id: string) {
    this.channelListModel = [{ id, name: id }];
  }

  get channel() {
    return this.channelListModel[0].id;
  }

  get localParametersConfig(): ParameterConfig[] {
    return this.parametersConfig;
  }

  get allParamsFilled() {
    return (
      this.contentFields.length ==
      this.paramsArrayConfig.filter(parameter => parameter[0].type != "").length
    );
  }

  async getNotificationTemplateById(id: string) {
    try {
      const response = await this.notificationTemplateService.getTemplateById(
        id
      );

      if (response.code === Http.Found && response.data) {
        this.notificationForm.templateName = response.data.name as string;
        this.category = response.data.appCategory as Array<string>;
        this.channel = response.data.appChannel as string;
        this.type = response.data.appType as string;
        this.notificationForm.state = response.data.state === ACTIVE;

        this.rawContentPreview = response.data.data;
        this.handleContentPreview(response.data.data);
        this.contentFields.length = this.getHowManyFieldPreviewHas(
          this.rawContentPreview,
          this.CONTENT_PREVIEW_IDENTIFICATOR
        );
        this.openPanels();
        this.loadConfigParams(response.data.configParameters!);
        this.notificationForm.paramsArrayConfig = this.paramsArrayConfig;

        this.editComparationStr = JSON.stringify({
          ...this.notificationForm,
          category: this.category,
          channel: this.channel,
          type: this.type
        });
        this.activateSaveBtn = this.allParamsFilled;
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(NOTIFICATION_TEMP_MESSAGES.ERROR_FETCHING_DETAILS);
    }
  }

  getHowManyFieldPreviewHas(content: string, indentificator: RegExp) {
    return content.split(indentificator).length - 1;
  }

  fieldModified() {
    const aux = this.rawContentPreview;
    this.contentPreview = this.replace(
      aux,
      this.contentFields,
      this.CONTENT_PREVIEW_IDENTIFICATOR
    );
  }

  replace(str: string, data: Array<string>, indentificator: RegExp) {
    let thereAreMore = true;
    let index = 0;
    while (thereAreMore) {
      const exist = str.search(indentificator);
      if (exist >= 0) {
        str = str.replace(indentificator, data[index]);
        index++;
      } else {
        thereAreMore = false;
      }
    }
    return str;
  }

  getFieldName(index: number) {
    return `${this.FIELD} ${index + 1}`;
  }

  getTypeName(value: string) {
    return this.localParametersConfig[0].fields?.find(e => e.type == value)
      ?.name;
  }

  handleContentPreview(data: string) {
    const content: Array<string> = data.split("|");
    this.rawContentPreview = content[0];
    this.contentPreview = this.rawContentPreview;
    if (content.length > 1) {
      const link = content[1]
        .trim()
        .slice(1, -1)
        .split(",");
      this.contentPreviewLink.key = link[0];
      this.contentPreviewLink.link = link[1];
    }
  }

  confirmDialog(action: string) {
    this.modalDialog = true;
    switch (action) {
      case this.UPDATE_TEMP:
        this.ACTION = this.UPDATE_TEMP;
        this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
        this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
        break;
    }
  }

  async handleModalAccept() {
    const template: UpdateNotificationTemplate = new UpdateNotificationTemplate();

    const index = this.notificationForm.category.indexOf(
      NOTIFICATION_TEMP_CONSTANTS.OTHER
    );

    if (this.ACTION === this.UPDATE_TEMP) {
      if (index >= 0) this.notificationForm.category.splice(index);

      template.appCategory = this.notificationForm.category;
      template.state = this.notificationForm.state ? ACTIVE : INACTIVE;
      template.name = this.notificationForm.templateName;
      template.configParameters = this.formatParamsToSave();

      await this.updateTemplate(template, this.localNotificationTemplateIdProp);
    }
    this.modalDialog = false;
    this.$emit(EMIT_EVENTS.SHOW_NOTIFICATION_TEMPLATE, true);
  }

  handleModalCancel() {
    this.modalDialog = false;
  }

  async updateTemplate(template: UpdateNotificationTemplate, id: string) {
    try {
      const response = await this.notificationTemplateService.updateTemplate(
        template,
        id
      );

      if (response.code === Http.Ok) {
        Snackbar.popSuccess(response.message);
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + NOTIFICATION_ACCESS.PUT
        );
      else Snackbar.popError(NOTIFICATION_TEMP_MESSAGES.ERROR_UPDATING);
    }
  }

  handleEditModalCancel() {
    this.editDialog = false;
  }

  handleChannelChange() {
    this.chosenList = this.channelList;
    this.editDialog = true;
  }

  handleCategoriesChange() {
    this.chosenList = this.categoryList;
    this.editDialog = true;
  }

  @Watch("paramsArrayConfig", { deep: true })
  onUpdateParamsArrayConfig() {
    this.notificationForm.paramsArrayConfig = this.paramsArrayConfig;
    Vue.set(this, "activateSaveBtn", this.allParamsFilled);
  }

  @Watch("category")
  checkCategory() {
    this.notificationForm.category = this.categorylListModel.map(
      item => item.id
    );
  }
  @Watch("channel")
  checkChanel() {
    this.notificationForm.channel = this.channelListModel[0].id;
  }
  @Watch("type")
  checkType() {
    this.notificationForm.type = this.typeListModel[0].id;
  }

  @Watch("notificationForm", { deep: true })
  checkEdit() {
    if (this.localNotificationTemplateIdProp) {
      this.invalidEdit =
        JSON.stringify(this.notificationForm) === this.editComparationStr;
    }
  }

  handleTypeChange() {
    this.chosenList = this.typeList;
    this.editDialog = true;
  }

  async saveList(items: Array<string>, id: string) {
    try {
      this.editDialog = false;
      const response = await this.notificationTemplateService.updateList(
        id,
        items
      );

      if (response.code === Http.Ok) {
        const itemsList = items.map(item => {
          return { id: item, name: item };
        });
        switch (this.chosenList.name) {
          case LISTS_NAMES.CHANNEL:
            this.channelListConfig.listAll = [
              ...this.channelListConfig.listAll,
              ...itemsList
            ];
            break;
          case LISTS_NAMES.CATEGORY:
            this.categorylListConfig.listAll = [
              ...this.categorylListConfig.listAll,
              ...itemsList
            ];
            break;
          case LISTS_NAMES.TYPE:
            this.typeListConfig.listAll = [
              ...this.typeListConfig.listAll,
              ...itemsList
            ];
            break;
        }

        Snackbar.popSuccess(response.message);
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.PUT);
      else Snackbar.popError(NOTIFICATION_TEMP_MESSAGES.ERROR);
    }
  }

  closePreview() {
    this.documentDialog = false;
  }

  onCloseModal() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
  }

  openPanels() {
    const param = lodash.cloneDeep(this.localParametersConfig);
    const keys = Object.keys(param).map(e => Number(e));
    for (let i = 0; i < this.localParametersConfig.length; i++) {
      this.paramsPanels[i] = keys;
    }
  }

  onSelectParamType(field: number, typeSelected: string) {
    if (!typeSelected) {
      return;
    }
    const paramConfig = lodash.cloneDeep(this.localParametersConfig);
    const arrayConfig = paramConfig.map(item => {
      let newFields = lodash.cloneDeep(item.fields);
      if (item.collection != "") {
        newFields = newFields
          ?.map(e => {
            return {
              ...e,
              checked: false
            };
          })
          .filter(option => {
            return option.type == typeSelected;
          });
      }
      return {
        ...item,
        type: typeSelected,
        fields: newFields
      };
    });
    Vue.set(this.paramsArrayConfig, field, arrayConfig);
  }

  onSelectParamField(key: number, collection: string) {
    let arrayConfig = lodash.cloneDeep(this.paramsArrayConfig[key]);
    const fieldsSelectedCurrentCollection = arrayConfig
      .find(e => e.collection == collection)
      ?.fields?.find(e => e.checked);
    arrayConfig = arrayConfig.map(parameter => {
      let toDisabled = false;
      if (
        parameter.collection != "" &&
        parameter.collection != collection &&
        fieldsSelectedCurrentCollection
      ) {
        toDisabled = true;
      }
      return {
        ...parameter,
        disabled: toDisabled
      };
    });
    Vue.set(this.paramsArrayConfig, key, arrayConfig);
  }

  async loadConfigParams(data: ParameterConfig[] = []) {
    for (let i = 0; i < this.contentFields.length; i++) {
      let paramsToArray = lodash.cloneDeep(this.localParametersConfig);
      if (data && data.length > 0) {
        const itemResponse = data[i];
        let collectionSelected = "";
        paramsToArray = paramsToArray.map(el => {
          if (el.collection == "") {
            return {
              ...el,
              type: itemResponse.type!
            };
          }
          const newFields = el.fields
            ?.map(field => {
              const fieldSelected =
                itemResponse.collection == el.collection &&
                itemResponse.fields?.find(item => item.id == field.id);
              if (collectionSelected == "" && fieldSelected) {
                collectionSelected = el.collection!;
              }
              return {
                ...field,
                checked: fieldSelected ? true : false,
                type: itemResponse.type
              };
            })
            .filter(e => e.type == itemResponse.type);
          return {
            type: itemResponse.type,
            collection: el.collection,
            fields: newFields,
            visualName: el.visualName,
            disabled: collectionSelected != el.collection
          };
        });
        Vue.set(this.paramsArrayConfig, i, paramsToArray);
      } else {
        Vue.set(
          this.paramsArrayConfig,
          i,
          paramsToArray.filter(e => !e.collection)
        );
      }
    }
  }

  formatParamsToSave(): ParameterConfig[] {
    const parameterConfig: ParameterConfig[] = [];
    for (let i = 0; i < this.contentFields.length; i++) {
      const item = this.paramsArrayConfig[i];
      let dataType = "";
      let collection = "";
      let selectedFields: NotificationParams[] = [];
      item.forEach(element => {
        if (element.collection == "") {
          return;
        }
        dataType = element.type!;
        const selected = item
          .find(e => e.collection == element.collection)
          ?.fields?.filter(e => e.checked)
          .map(e => {
            return {
              id: e.id,
              name: e.name,
              editable: false
            };
          });
        if (selected && selected.length > 0) {
          collection = element.collection!;
          selectedFields = selected;
        }
      });
      parameterConfig.push({
        type: dataType,
        collection: collection,
        fields: selectedFields
      });
    }
    return parameterConfig;
  }
}
